import Image from 'next/legacy/image'
import { BlockComponent } from 'lib'
import { CardLayout } from '../components/Layout'
import { ROUTES } from 'parameters/index'
import { buildDashItem } from 'experiences/dashboard/DashboardRoot/lib/types'
import { ExternalIcon } from 'components/content/icons'
import { LinkButton } from 'ui/inputs/Button/LinkButton'

const CreditScoreCard: BlockComponent = () =>
	CardLayout({
		title: 'Check Your Credit Score for Free With',
		graphic: <Image src="/images/credit-score.svg" width="98" height="96" alt="Credit score icon" />,
		body: (
			<Image src="/images/transunion-logo.png" width="160" height="26" objectFit={'contain'} alt="TransUnion logo" />
		),
		footer: (
			// Link Button
			<LinkButton href={ROUTES.CREDIT_SCORE_EXTERNAL} target="_blank">
				Get Your Score <ExternalIcon />
			</LinkButton>
		)
	})

export const CreditScoreDashItem = buildDashItem(<CreditScoreCard />)
